import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ngxui-sidenav-title-menu',
  templateUrl: './sidenav-title-menu.component.html',
  styleUrls: ['./sidenav-title-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidenavTitleMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
